export const LIST_TYPES_DATABASES = [
    {
        id: 1,
        name: "MySql",
    },
    {
        id: 2,
        name: "Mongo DB",
    },
    {
        id: 3,
        name: "Redis",
    },
];

export const LIST_CLOUD = [
    {
        id: "infra704",
        name: "INFRA704",
    },
    {
        id: "digitalocean",
        name: "DigitalOcean",
    },
    {
        id: "aws",
        name: "AWS",
    },
    {
        id: "cloud",
        name: "CLOUD",
    },
];
